@if (categoryData$ | async; as component) {
  <boels-vertical-aligner innerWidth="wide">
    <h1 class="boels-subcategories__title">{{ component.name }}</h1>
    @if (component.description; as description) {
      <div
        class="boels-subcategories__text"
        boelsQa="description"
        [innerHTML]="description | prepareHtml"
      ></div>
    }
    <div class="boels-subcategories__list">
      @for (categoryItem of component.subcategories; track categoryItem) {
        <boels-category-item [categoryItem]="categoryItem">
        </boels-category-item>
      }
    </div>
    @if (component.seoText; as seoText) {
      <hr />
      <div
        class="boels-subcategories__seo-text"
        [innerHTML]="seoText | prepareHtml"
        boelsQa="seoText"
      ></div>
    }
  </boels-vertical-aligner>
}
